import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { ProjectSetService } from './api/projectSet.service';
import { TaskSetService } from './api/taskSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ProjectApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ProjectApiModule> {
        return {
            ngModule: ProjectApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ProjectApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ProjectApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
